import React from "react";
import {
  Image
} from "@fluentui/react";
import { ActivityItem, IActivityItemProps, Persona, PersonaSize } from "office-ui-fabric-react";
import Moment from "react-moment";
import moment from "moment";
import { TruckComment } from "../../../models";
import SofIcon from "../../common/Icons";

interface IProps {
  comments: TruckComment[]
}

const CommentHistory = ({
  comments
}: IProps) => {

  const commentActivities = comments.map(
    (c, index: number) =>
      ({
        key: index,
        activityDescription: [
          <table key={index}>
            <tr>
              <td rowSpan={2} style={{ verticalAlign: "top" }}>
                <span style={{
                  display: "inline-block",
                  paddingRight: "10px",
                  width: "40px",
                }}>
                  {c.profilePicture && (
                    <Image
                      style={{
                        borderRadius: "50%",
                        height: "auto",
                      }}
                      src={`data:image/jpeg;base64, ${c.profilePicture}`}
                      width="30"
                      height="30"
                    />
                  )}
                  {!c.profilePicture && (
                    <Persona
                      size={PersonaSize.size28}
                      initialsColor={"#4C4C4C"}
                      color={"#4C4C4C"}
                      imageInitials={c.submittedByName
                        .split(" (")[0]
                        .split(" ")
                        .map((n, i, a) =>
                          i === 0 || i + 1 === a.length ? n[0] : null
                        )
                        .join("")}
                    />
                  )}
                </span>
              </td>
              <td>
                <b key={`submittedby-${index}`}>{c.submittedByName}</b>&nbsp;
                <Moment format="HH:mm - ll">
                  {moment.utc(c.submittedOn).local().toDate()}
                </Moment>
              </td>
            </tr>
            <tr>
              <td>
                <div style={{whiteSpace: "pre-wrap"}}>{c.commentText}</div>
              </td>
            </tr>
          </table>,
        ],
      } as IActivityItemProps | { key: number })
  );

  return (
    <>
      {commentActivities.length > 0 ?
          commentActivities.map((a, index: number) => (
            <ActivityItem
              key={`comment-${index}`}
              {...a}
              style={{ marginBottom: 4 }}
            />
          ))
          : <div style={{
            width: "100%",
            textAlign: "center",
          }}>
              <div style={{ 
                width: "70px",
                height: "70px",
                borderRadius: "35px",
                backgroundColor: "#E2E6E8",
                display: "block",
                padding: "22px",
                margin: "10px auto"}}>
                <SofIcon iconname="NoComment" />
              </div>
              <div style={{
                color: "#B8B8B8",
                fontSize: "18px",
                fontWeight: "bold",
              }}>No Comments Yet</div>
            </div>
        }
    </>
  )
}

export default CommentHistory;